// SPDN Script Priority Configuration
// Higher priority = loads sooner
window.SPDN_PRIORITIES = {
  // High priority: Critical for functionality
  high: [
    'globo',         // Globo Mega Menu - must load instantly
    'globomenu',     // Globo menu variations
    'gm-menu',       // Globo menu class
    'builder',       // Page builder
    'stripe',        // Payment (if on checkout/cart)
    'caffeine',      // Caffeine app embed
    'recommendations', // Caffeine recommendations widget
  ],
  
  // Medium priority: Important but not critical
  medium: [
    'klaviyo',       // Email marketing
    'yotpo',         // Reviews
    'privy',         // Customer service
    'quadpay',       // Payment options
  ],
  
  // Low priority: Analytics and tracking
  low: [
    'gtag',          // Google Analytics
    'gtm',           // Google Tag Manager
    'tagmanager',    // Tag Manager
    'clarity',       // Microsoft Clarity
    'analytics',     // Generic analytics
    'tiktok',        // TikTok Analytics
    'facebook',      // Facebook Pixel
    'bing',          // Bing Ads
    'hotjar',        // Hotjar
    'xklaviyo',      // Klaviyo analytics
  ]
};

// Get priority for a script
window.getSPDNPriority = function(script) {
  if (!script) return 'low';
  
  var src = (script.src || '').toLowerCase();
  var inner = (script.innerHTML || script.innerText || '').toLowerCase();
  var content = src + ' ' + inner;
  
  // Check high priority first
  for (var i = 0; i < window.SPDN_PRIORITIES.high.length; i++) {
    var vendor = window.SPDN_PRIORITIES.high[i];
    if (content.indexOf(vendor) !== -1) {
      return 'high';
    }
  }
  
  // Check medium priority
  for (var i = 0; i < window.SPDN_PRIORITIES.medium.length; i++) {
    var vendor = window.SPDN_PRIORITIES.medium[i];
    if (content.indexOf(vendor) !== -1) {
      return 'medium';
    }
  }
  
  // Check low priority
  for (var i = 0; i < window.SPDN_PRIORITIES.low.length; i++) {
    var vendor = window.SPDN_PRIORITIES.low[i];
    if (content.indexOf(vendor) !== -1) {
      return 'low';
    }
  }
  
  // Default to low for unknown scripts
  return 'low';
};

